import React, { FC, memo, useCallback, useEffect, useState } from 'react'
import classes from './SingleInputHeader.module.scss'
import { useGetWorkerInfo } from '../../../hooks/api/workers/useGetWorkerInfo'
import { Switch, TextField, useTheme } from '@mui/material'
import SingleDatePicker from '../../uikit/atoms/datepickers/SingleDatePicker'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
//キャンセル
import CancelIcon from '@mui/icons-material/Cancel'
import {
  compareTimeTable,
  getTimesDownTo,
  getTimesUpTo,
  timeList,
} from '../../../utils/variables/timeList'
import SelectBoxForString from '../../uikit/atoms/selectboxes/SelectBoxForString'
import {
  calcTotalTimeByDiary,
  calcTotalTimeByFromAndTo,
} from '../../../utils/functions/calcTotalTime'
import { useRecoilState } from 'recoil'
import { UNSPECIFIED_FACTORY_NO, userState } from '../../../states/userState'
import { User, Worker } from '../../../types'
import { workerInfoType } from '../SingleInputMain'
import { Dirary } from '../../../types/dirary'
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager'
import { formatDate } from '../../../utils/functions/formatting'
import { useGetDiaryList } from '../../../hooks/api/posts/useGetDiraryList'
import { Buttons } from '../../uikit/atoms/buttons/Buttons'
import WorkerSearchDialog from '../../modal/workerSearch/WorkerSearchDialog'
import SelectBoxForNumber from '../../uikit/atoms/selectboxes/SelectBoxForNumber'
import { breakTimeList } from '../../../utils/variables/breakTime'
import { formatWorkerId } from '../../../utils/variables/workerId'

type Props = {
  setTotalTime: React.Dispatch<
    React.SetStateAction<{ hour: number; min: number; text: string }>
  >
  totalTime: { hour: number; min: number; text: string }
  workerInfo: {
    workerId: string
    workerName: string
    departmentId: null | number
    departmentName: null | string
    place: null | string
  }
  setWorkerInfo: React.Dispatch<React.SetStateAction<workerInfoType>>
  workingDate: {
    obj: Date
    text: string
  }
  setWorkingDate: React.Dispatch<
    React.SetStateAction<{
      obj: Date
      text: string
    }>
  >
  hasBreak: boolean
  setHasBreak: React.Dispatch<React.SetStateAction<boolean>>
  fromTime: string
  toTime: string
  setFromTime: React.Dispatch<React.SetStateAction<string>>
  setToTime: React.Dispatch<React.SetStateAction<string>>
  setFetchDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  diaryList: Dirary[]
  setDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  setIsShow?: React.Dispatch<React.SetStateAction<boolean>>
  fromOtherPage?: boolean
  breakTime: number
  setBreakTime: React.Dispatch<React.SetStateAction<number>>
  setDefaultFactoryNo: React.Dispatch<React.SetStateAction<number>>
}

const SingleInputHeader: FC<Props> = memo((props) => {
  const {
    totalTime,
    setTotalTime,
    workerInfo,
    setWorkerInfo,
    workingDate,
    setWorkingDate,
    hasBreak,
    setHasBreak,
    fromTime,
    toTime,
    setFromTime,
    setToTime,
    setFetchDiaryList,
    diaryList,
    setDiaryList,
    setDefaultFactoryNo,
    setIsShow = undefined,
    fromOtherPage = false,
    breakTime,
    setBreakTime,
  } = props
  const [user, setUser] = useRecoilState<User>(userState)
  const globalStateFactoryNo = user.initialParameters.factoryNoForSingleInput
  const theme = useTheme()
  const getWorkerInfo = useGetWorkerInfo()
  const [isWorkerSearchOpen, setIsWorkerSearchOpen] = useState(false)
  const { getDiaryListByWokerAndDay } = useGetDiaryList()
  //社員マスタ情報-4
  // const [workerInfo, setWorkerInfo] = useState({
  //   workerId: "",
  //   workerName: "",
  //   departmentId: null,
  //   departmentName: null,
  //   place: null,
  // });

  //エラーメッセージ-2
  const [errorWorkerName, setErrorWorkerName] = useState({
    isShow: true,
    text: '',
  })

  const [fromTimeList, setFromTimeList] =
    useState<{ id: string; name: string }[]>(timeList)
  const [toTimeList, setToTimeList] =
    useState<{ id: string; name: string }[]>(timeList)

  // const [toTimeList, setToTimeList] = useState<{ id: string; name: string }[]>(
  //   getTimesDownTo(timeList, fromTime)
  // );

  //社員番号入力
  const handleChangeWorkerId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= 5) {
      setWorkerInfo((prevState) => ({
        ...prevState,
        workerId: e.target.value,
      }))
      if (e.target.value.length == 0) {
        setErrorWorkerName({ isShow: true, text: '' })
      } else {
        setErrorWorkerName({ isShow: false, text: '' })
      }
      // setErrorWorkerName({ isShow: true, text: "未設定" });
    }
  }
  //フォーカスが当たったとき
  const handleFocusWorkerId = () => {
    //フェッチ用のリストを初期化
    setFetchDiaryList([])
    setWorkerInfo((prevState) => ({
      ...prevState,
      workerId: '',
      workerName: '',
      departmentId: null,
      departmentName: null,
      place: null,
      jobId: null,
    }))
    setErrorWorkerName({ isShow: true, text: '' })
    //リコイルを更新
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          workerSingleForInput: null,
        },
      }
      setUserToLocalStorage(newUser)
      return newUser
    })
  }
  //フォーカスが外れたとき
  const handleBlurWorkderId = async () => {
    if (workerInfo.workerId.length > 0) {
      const res = await getWorkerInfo(workerInfo.workerId)
      if (res) {
        const lworkerId = res[5]

        setWorkerInfo((prevState) => ({
          ...prevState,
          workerId: formatWorkerId(res[5]),
          workerName: res[0],
          departmentId: res[1],
          departmentName: res[6],
          place: res[3],
          jobId: res[2],
        }))

        setErrorWorkerName({
          isShow: false,
          //text: `${res[6]}`,
          text: '',
        })
        //リコイルを更新
        if (globalStateFactoryNo === UNSPECIFIED_FACTORY_NO) {
          setDefaultFactoryNo(Number(res[3]))
          setUser((prevUser: User) => {
            const newWorker: Worker = {
              workerId: formatWorkerId(res[5]),
              workerName: res[0],
            }
            const newUser: User = {
              ...prevUser,
              initialParameters: {
                ...prevUser.initialParameters,
                workerSingleForInput: newWorker,
                factoryNo: [Number(res[3])],
                factoryNoForSingleInput: Number(res[3]),
                factoryNoForMultiInput: Number(res[3]),
                factoryNoForMatrix: Number(res[3]),
                factoryNoForOutsourcingCc: Number(res[3]),
                factoryNoForOutsourcingTo: Number(res[3]),
              },
            }
            setUserToLocalStorage(newUser)
            return newUser
          })
        } else {
          setUser((prevUser: User) => {
            const newWorker: Worker = {
              workerId: res[5],
              workerName: res[0],
            }
            const newUser: User = {
              ...prevUser,
              initialParameters: {
                ...prevUser.initialParameters,
                workerSingleForInput: newWorker,
              },
            }
            setUserToLocalStorage(newUser)
            return newUser
          })
        }

        const response = await getDiaryListByWokerAndDay(
          lworkerId,
          workingDate.text
        )
        // setDiaryList(response);
        setFetchDiaryList(response)
      } else {
        setFetchDiaryList([])
        setWorkerInfo((prevState) => ({
          ...prevState,
          workerName: '',
          departmentId: null,
          departmentName: null,
          place: null,
          jobId: null,
        }))
        setErrorWorkerName({ isShow: true, text: '' })
        //リコイルを更新
        setUser((prevUser: User) => {
          const newUser: User = {
            ...prevUser,
            initialParameters: {
              ...prevUser.initialParameters,
              workerSingleForInput: null,
            },
          }
          setUserToLocalStorage(newUser)
          return newUser
        })
      }
    }
  }
  //作業開始日が変更されたとき
  const handleWorkingDateChange = (newDate: any) => {
    setWorkingDate({ obj: newDate, text: formatDate(newDate) })
  }
  //開始時刻が変更されたとき
  const handleFromTimeChange = (e: string) => {
    setFromTime(() => {
      // setToTimeList(getTimesDownTo(timeList, e));
      return e
    })
  }
  useEffect(() => {
    //終了時刻強制セット
    // if (compareTimeTable(fromTime, toTime)) setToTime(toTimeList[0].id);
  }, [toTimeList])
  //時刻計算
  useEffect(() => {
    // const { hour, min, text } = calcTotalTimeByFromAndTo(
    //   fromTime,
    //   toTime,
    //   hasBreak
    // );
    const { hour, min, text, endTime } = calcTotalTimeByDiary(
      fromTime,
      diaryList,
      hasBreak,
      breakTime
    )
    setTotalTime({ hour, min, text })
    setToTime(endTime)
    setDiaryList((prevList) => {
      return prevList.map((diary: Dirary) => {
        // if (diary.workingDate === workingDate.text) {
        return {
          ...diary,
          startTime: fromTime,
          endTime: endTime,
          isBreak: hasBreak,
          breakTime: breakTime,
          totalWorkingTimeByHour: hour,
          totalWorkingTimeByMinute: min,
        }
        // } else {
        //   return diary;
        // }
      })
    })
  }, [fromTime, toTime, breakTime])
  //親要素の時刻更新

  //読み込み時の社員情報フェッチ
  useEffect(() => {
    handleBlurWorkderId()
  }, [workingDate.text, workerInfo.workerName])
  const checkFromTimeDisabled = useCallback(() => {
    if (diaryList.length > 0 && diaryList[0].isDisabled) {
      return true
    } else {
      return false
    }
  }, [diaryList])

  const handleBreakTimeChange = (e: number) => {
    setBreakTime(e)
    setHasBreak(e > 0)
  }

  return (
    <div className={classes.rootContainer}>
      <div className={classes.workerArea}>
        <div className={classes.kanaButton}>
          <p style={{ fontSize: '12px' }}>カナ検索</p>
          <Buttons
            disabled={false}
            onClick={() => setIsWorkerSearchOpen(true)}
            caption={'カナ'}
            icon={<PersonSearchIcon />}
            width={26}
            height={26}
            fontSize={24}
          />
        </div>
        <div className={`${classes.date}`}>
          <SingleDatePicker
            disabled={false}
            currentDate={workingDate.obj}
            label={'作業日'}
            onChange={handleWorkingDateChange}
          />
        </div>
        <div className={classes.input}>
          <TextField
            helperText={errorWorkerName.text}
            error={errorWorkerName.isShow}
            label="社員番号"
            variant="standard"
            type="number"
            multiline={false}
            value={workerInfo.workerId}
            sx={{
              height: '70px',
              width: '100px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              //スピンボタンの無効化-効いていない
              ':global(input[type="number"]::-webkit-outer-spin-button)': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              ':global(input[type="number"]::-webkit-inner-spin-button)': {
                WebkitAppearance: 'none',
                margin: 0,
              },

              '& .MuiInputBase-input': {
                color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                fontSize: '16px',
                // その他のスタイル設定...
              },
              '& label': {
                color: theme.palette.foreColor.main, // 通常時のラベル色
                //backgroundColor:"white"
              },
              '& label.Mui-focused': {
                color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
              },
              '& .MuiInput-underline:before': {
                borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
              },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                },
                '&:hover fieldset': {
                  borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                },
                '& .MuiInputBase-root': {},
              },
            }}
            onChange={handleChangeWorkerId}
            onFocus={handleFocusWorkerId}
            onBlur={handleBlurWorkderId}
            placeholder="1234or01234"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
        <div className={classes.display}>
          <p>{workerInfo.departmentName}</p>
          <p>{workerInfo.workerName}</p>
        </div>
      </div>
      <div className={classes.dateTimeArea}>
        <div className={classes.firstArea}>
          {/* <div className={classes.date}>
            <SingleDatePicker
              disabled={false}
              currentDate={workingDate}
              label={"作業日"}
              onChange={handleWorkingDateChange}
            />
          </div> */}
          <div className={classes.time}>
            <SelectBoxForString
              label={'開始時刻'}
              options={fromTimeList}
              required={true}
              select={handleFromTimeChange}
              value={fromTime}
              disabled={checkFromTimeDisabled()}
              width={'85px'}
              height={'34px'}
              fontSize={'16px'}
              setMode={'input'}
              colorMode={'light'}
            />
          </div>

          <div className={classes.breakTime}>
            <p
              style={{
                color: hasBreak ? theme.palette.foreColor.main : '#8d94a2',
              }}
            >
              休憩時間
            </p>
            {/* <Switch
              checked={hasBreak}
              onChange={() => setHasBreak(!hasBreak)}
              sx={{
                ...(!hasBreak
                  ? { color: "#4a4f58" }
                  : { color: theme.palette.foreColor.main }),
              }}
            /> */}
            <SelectBoxForNumber
              label={''}
              options={breakTimeList}
              required={true}
              select={handleBreakTimeChange}
              value={breakTime}
              disabled={false}
              width={'60px'}
              height={'32px'}
              fontSize={'16px'}
              colorMode={'light'}
              setMode={'input'}
            />
          </div>
          <div className={classes.totalTime}>
            <p>終了時刻</p>
            <div
              style={{
                color:
                  totalTime.hour <= 0
                    ? theme.palette.error.main
                    : theme.palette.foreColor.main,
              }}
            >
              <>{`${toTime.split(':')[0]}時${toTime.split(':')[1]}分`}</>
            </div>
          </div>
        </div>
        <div className={classes.secondArea}>
          {fromOtherPage && (
            <div className={classes.closeButton}>
              <Buttons
                disabled={false}
                onClick={() => (setIsShow ? setIsShow(false) : undefined)}
                caption={'キャンセル'}
                icon={<CancelIcon />}
                width={26}
                height={26}
                fontSize={26}
              />
            </div>
          )}
        </div>
      </div>
      <div className={classes.hr} />
      {isWorkerSearchOpen && (
        <WorkerSearchDialog
          setIsShow={setIsWorkerSearchOpen}
          setWorkerInfo={setWorkerInfo}
          setDefaultFactoryNo={setDefaultFactoryNo}
        />
      )}
    </div>
  )
})

export default SingleInputHeader
